import { Switch } from '@mantine/core';
import { ReactNode } from 'react';
import { FieldValues, useController } from 'react-hook-form';

import { FormControlInput } from '@/core/components';

export interface SwitchControlProps<T extends FieldValues> extends FormControlInput<T> {
  label: string;
  description?: string;
  placeholder?: string;

  isDisabled?: boolean;

  leftSection?: ReactNode;
}

export function SwitchControl<T extends FieldValues>(props: SwitchControlProps<T>) {
  const { label, placeholder, description, name, isSubmitting, isDisabled, control } = props;
  const {
    field,
    fieldState: { error },
  } = useController({ name, control });

  return (
    <Switch
      ref={field.ref}
      name={field.name}
      checked={field.value}
      onChange={field.onChange}
      label={label}
      description={description}
      placeholder={placeholder ?? label}
      error={error?.message}
      disabled={isSubmitting || isDisabled}
      flex={1}
    />
  );
}
